import React from 'react';
import Container from 'container';
import { Link } from 'gatsby';
import Icon from 'icon';
import s from './breadcrumbs.module.scss';

export default function Breadcrumbs({ pages, grey, ...props }) {
  return (
    <Container className={`${s.root} ${grey ? s.grey : ''}`}>
      <div className={s.wrapper}>
        <a className={s.home} href="https://cohortcs.com/">
          <Icon icon="house" className={s.house} />
          <span className={s.homeText}>Home</span>
        </a>
        {pages?.map(({ name, href }, i) => {
          const lastClass = i === pages.length - 1 ? s.last : '';
          return (
            <>
              <Separator />
              {href ? (
                <span className={`${s.linkWrapper} ${lastClass}`}>
                  <Link to={href} className={`${s.page} ${s.link}`}>
                    {name}
                  </Link>
                </span>
              ) : (
                <span className={`${s.page} ${lastClass}`}>{name}</span>
              )}
            </>
          );
        })}
      </div>
    </Container>
  );
}

function Separator() {
  return (
    <div className={s.separator}>
      <Icon icon="greater" className={s.greater} />
    </div>
  );
}
